// Centralized WhatsApp link helpers.
//
// Why: `wa.me` redirects to `api.whatsapp.com/send` on desktop, which is
// blocked in some networks/browsers (ERR_BLOCKED_BY_RESPONSE). Using
// `web.whatsapp.com/send` directly on desktop avoids this redirect.
// On mobile, `wa.me` opens the WhatsApp app directly and is the most reliable.

export function cleanPhone(phone: string | null | undefined): string {
  return (phone ?? "").replace(/\D/g, "");
}

function isMobile(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod|Mobile|Opera Mini|IEMobile/i.test(
    navigator.userAgent
  );
}

/**
 * Build a WhatsApp URL that avoids the blocked api.whatsapp.com page.
 * Returns null if the phone number is invalid (less than 8 digits).
 */
export function buildWhatsAppUrl(
  phone: string | null | undefined,
  message?: string
): string | null {
  const clean = cleanPhone(phone);
  if (clean.length < 8) return null;
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  if (isMobile()) {
    return `https://wa.me/${clean}${text}`;
  }
  // Desktop: go straight to WhatsApp Web to avoid api.whatsapp.com redirect.
  const params = new URLSearchParams({ phone: clean });
  if (message) params.set("text", message);
  return `https://web.whatsapp.com/send?${params.toString()}`;
}
